import { render, staticRenderFns } from "./AutoLogoutComponent.vue?vue&type=template&id=6d7163c8"
import script from "./AutoLogoutComponent.vue?vue&type=script&lang=js"
export * from "./AutoLogoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports